import React, { Component } from "react";
import { Provider } from "react-redux";
import { applyMiddleware, compose, createStore } from "redux";
import { createEpicMiddleware } from "redux-observable";
import { persistStore, persistReducer } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import { BrowserRouter } from "react-router-dom";
import RosterPlanner from "./containers/RosterPlanner";
import { useSessionIdling } from "./components/TokenRefresher";
import combinedEpics from "./actions/combinedEpics";
import baseReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["persistParams"],
};

class App extends Component {
  constructor() {
    super();
    // eslint-disable-next-line
    const composeEnhancers =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const epicMiddleware = createEpicMiddleware();

    this.store = createStore(
      persistReducer(persistConfig, baseReducer),
      composeEnhancers(applyMiddleware(epicMiddleware))
    );

    this.persistor = persistStore(this.store);

    epicMiddleware.run(combinedEpics);
  }

  render() {
    useSessionIdling();

    return (
      <Provider store={this.store}>
        <PersistGate loading={null} persistor={this.persistor}>
          <BrowserRouter basename="/dcrp">
            <RosterPlanner />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
